import React from 'react'
import styled from 'styled-components'

export interface PosterImageProps {
    src: string
}

const StyledPosterImage = styled.div`
    width: 100%;
    aspect-ratio: auto 16 / 9;
    padding: 0;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`

const StyledOverlay = styled.div`
    background: rgba(0, 0, 0, 0.1);
    height: 100%;
`

const StyledPosterImageBackground = styled.div`
    ${({ src }: { src: string }) => `
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-image: url(${src});
        background-size: cover;
        background-position: center;
        filter: blur(20px);
    `}
`

const StyledImage = styled.img`
    position: relative;
    width: 25%;
    aspect-ratio: auto 1 / 1;
    filter: drop-shadow(0px 4px 12px rgba(0, 0, 0, 0.5));
    border-radius: 12px;
    z-index: 1;
`

export const PosterImage: React.FC<PosterImageProps> = ({ src }) => {
    return (
        <StyledPosterImage>
            <StyledImage src={src} />
            <StyledPosterImageBackground src={src}>
                <StyledOverlay />
            </StyledPosterImageBackground>
        </StyledPosterImage>
    )
}

export default React.memo(PosterImage)
